import React, { useContext } from "react";
import { AuthContext } from "../context/Auth";
import { Navigate } from "react-router-dom";

export const AdminOnly = ({ children }) => {
    const { signed, isAdmin, authChecked } = useContext(AuthContext);

    // Sem isso, uma visita direta (ou reload) numa rota protegida via esta guarda
    // redirecionava pro login mesmo com sessão válida — a leitura do localStorage
    // ainda não tinha terminado na primeira renderização. Ver Gotchas.
    if (!authChecked) {
        return null;
    }

    if (!signed) {
        return <Navigate to="/" />;
    }

    if (!isAdmin) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                    <div className="text-center">
                        <h2 className="text-2xl font-bold text-red-600 mb-4">
                            Acesso Negado
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Você não tem permissão para acessar esta área. 
                            Apenas administradores podem acessar o painel administrativo.
                        </p>
                        <button
                            onClick={() => window.location.href = '/'}
                            className="bg-accent hover:bg-accent-hover text-white font-bold py-2 px-4 rounded-md"
                        >
                            Voltar ao Login
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return children;
}; 